import { render, staticRenderFns } from "./IconSvgPlayCircle.vue?vue&type=template&id=3d378449&scoped=true&"
import script from "./IconSvgPlayCircle.vue?vue&type=script&lang=js&"
export * from "./IconSvgPlayCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d378449",
  null
  
)

export default component.exports